import React, { useState } from 'react';
import UnitDetailCard from '@AMIEWEB/Order/OrderCreationForm/Common/UnitDetailCard';
import { theme } from 'styles/global-styles';
import { useTranslation } from 'react-i18next';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { OrderExperienceSet } from './OrderExperienceSet';
import { usePromiseTracker } from 'react-promise-tracker';
import { Skeleton } from '@mui/material';

export const ExperienceSetWrapper = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const [experienceCount, setExperienceCount] = useState(0);
  const { promiseInProgress: fetchingUnitSkillSet } = usePromiseTracker({ area: 'unit-skillsetdetails', delay: 0 });
  const { fields: groupFields } = useFieldArray({
    control,
    name: 'skillSetGroup.groups',
  });

  return fetchingUnitSkillSet ? (
    <UnitDetailCard
      title={`${t('facility.units.unitDetails.unitRequirements.experience')}: ${experienceCount}`}
      customBackgroundColor={theme.palette.system.paperBackground}
      hideRemoveSection={false}
    >
      <Skeleton height={100} width="100%" />
    </UnitDetailCard>
  ) : (
    <UnitDetailCard
      title={`${t('facility.units.unitDetails.unitRequirements.experience')}: ${experienceCount}`}
      customBackgroundColor={theme.palette.system.paperBackground}
      hideRemoveSection={false}
    >
      {groupFields?.map((groupField, groupIndex) => (
        <OrderExperienceSet
          groupIndex={groupIndex}
          groupField={groupField}
          setExperienceCount={setExperienceCount}
          key={groupField.id}
        />
      ))}
    </UnitDetailCard>
  );
};
